var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flags-list"},_vm._l((_vm.flags),function(flag){return _c('li',{key:flag},[_c('Chip',{staticClass:"flags-item",class:_vm.getFlagColor(flag),attrs:{"chipContent":flag}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }